import { useNuxtApp } from "#app";

export const normalizeTranslationString = (value: string): string => {
  const { $i18n } = useNuxtApp();

  return value.startsWith("$t:") ? $i18n.t(value.slice(3)) : value;
};
